import { memo, useState } from "react";
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from "react-router-dom";
import NotFound from "pages/404";
import { privateRoutes, publicRoutes } from "routes";
import PublicRouter from "./publicRouter";
import PrivateRouter from "./privateRouter";
import { ToastContainer } from "react-toastify";
import Unauthorized from "pages/401";
import InternalServerError from "pages/500";
import ForbiddenError from "pages/403";
import BrowserService from "service/browser.service";

function RoutesComponent() {
    const isAuthenticated = () => {
        const authDetails = JSON.parse(localStorage.getItem("authDetails"));
        const token = BrowserService.getCookie("token");
        if (!token && !authDetails) {
            localStorage.removeItem("authDetails");
            return false;
        }
        return true;
    };

    const render = () => {
        return (
            <>
                {/* Public Route List  */}
                {publicRoutes.map(({ title, path, element: Element, ...rest }) => (
                    <Route
                        key={title}
                        element={<PublicRouter title={title} {...rest} auth={isAuthenticated()} />}
                    >
                        <Route path={path} element={<Element />} />
                    </Route>
                ))}

                {/* Private Route List */}
                {privateRoutes.map(({ title, path, allowedRoles, element: Element, ...rest }) => (
                    <Route
                        key={title}
                        element={
                            <PrivateRouter allowedRoles={allowedRoles} title={title} {...rest} auth={isAuthenticated()} />
                        }
                    >
                        <Route path={path} element={<Element />} />
                    </Route>
                ))}

                <Route path={'/unauthorized'} element={<Unauthorized />} />
                <Route path={'/server-error'} element={<InternalServerError />} />
                <Route path={'/access-denied'} element={<ForbiddenError />} />
                <Route path={'/*'} element={<NotFound />} />
            </>
        )
    }

    // Create the router exactly once for the lifetime of the app. Building it inside
    // the render body recreated it on every render, which desynced React Router 7's
    // internal navigation state from the React tree (URL changed but the page didn't).
    const [router] = useState(() => createBrowserRouter(createRoutesFromElements(render())));

    return <> <ToastContainer /><RouterProvider router={router} /></>

}

export default memo(RoutesComponent)